export const OBIE_LINK = "https://www.obieinsurance.com/partner/constitution-lending";
export const OBIE_LOGO = 'https://cdn.prod.website-files.com/67b6368ed9b90d69d1b3c14e/67da0cc4012f98916ef3551e_Logo.svg';